var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 48,
    viewBox: "0 0 116 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.12 48V0.831997H27.256L34.36 7.936V19.008L31.288 22.464L36.472 27.584V40.896L29.368 48H0.12ZM8.12 19.776H23.544L26.296 16.576V10.688L23.48 7.872H8.12V19.776ZM8.12 40.96H25.592L28.408 38.144V29.632L25.592 26.816H8.12V40.96ZM40.9525 48L52.7925 30.912L40.9525 14.528H50.2325L58.9365 27.2H60.4725L69.1125 14.528H78.3925L66.6165 30.848L78.3925 48H68.9205L60.4085 34.752H58.8085L50.4885 48H40.9525ZM83.3505 48V38.208L107.479 16.448V10.688L104.663 7.872H92.8225L88.1505 12.544L82.9025 7.232L89.3025 0.831997H108.375L115.479 7.936V19.776L92.4385 40.704H115.927V48H83.3505Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f88137875a0a2236881ecb2c3a6c6fc.svg";
export { ForwardRef as ReactComponent };